<template>
    <nav v-if="lastPage > 1" class="activity-pagination" data-testid="activity-pagination">
        <ul class="pagination">
            <li :class="{ disabled: currentPage <= 1 }">
                <a href="#" aria-label="Previous" data-testid="pagination-prev" @click.prevent="goTo(currentPage - 1)">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            <li v-for="page in visiblePages" :key="page" :class="{ active: page === currentPage }">
                <a href="#" @click.prevent="goTo(page)">{{ page }}</a>
            </li>
            <li :class="{ disabled: currentPage >= lastPage }">
                <a href="#" aria-label="Next" data-testid="pagination-next" @click.prevent="goTo(currentPage + 1)">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
const MAX_VISIBLE_PAGES = 5;

export default {
    name: 'ActivityPagination',
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        lastPage: {
            type: Number,
            required: true
        }
    },
    computed: {
        visiblePages() {
            const half = Math.floor(MAX_VISIBLE_PAGES / 2);
            let start = Math.max(1, this.currentPage - half);
            const end = Math.min(this.lastPage, start + MAX_VISIBLE_PAGES - 1);
            start = Math.max(1, end - MAX_VISIBLE_PAGES + 1);

            const pages = [];
            for (let page = start; page <= end; page++) {
                pages.push(page);
            }
            return pages;
        }
    },
    methods: {
        goTo(page) {
            if (page < 1 || page > this.lastPage || page === this.currentPage) {
                return;
            }
            this.$emit('pagechanged', page);
        }
    }
};
</script>

<style scoped>
.activity-pagination {
    text-align: center;
}
</style>
